import { Switch } from '@headlessui/react';


const SlideToggle = (props) => {
    const { active, onChange, disabled, whenActive, whenInactive } = props;


    const handleChange = (e) => {
        if (e === true){
            onChange(whenActive || e);
        }
        else{
            onChange(whenInactive || e);
        }
    }

    
    return (
        <Switch
            as="button"
            checked={active}
            onChange={(e) => handleChange(e)}
            disabled={disabled}
            className={`
                relative inline-flex w-10 h-6 items-center rounded-full transition-all duration-300
                ${active ? 'bg-ep-primary' : 'bg-gray-300'}
                ${disabled ? 'cursor-default' : 'cursor-pointer'}
            `}
        >
            <div className={`inline-block w-5 h-5 transform transition-all duration-300 rounded-full bg-white ${active ? 'absolute right-0.5' : 'ml-0.5'}`} />
        </Switch>
    )
}


export default SlideToggle;